import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  HostListener,
  PLATFORM_ID,
  Inject,
  NgZone,
} from "@angular/core";
import { Router } from "@angular/router";
import { isPlatformBrowser, isPlatformServer } from "@angular/common";
// ngrx store
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";

// services
import { BookingService } from "../../services/booking.service";
import { EventsService } from "../../services/events.service";
import { TimeslotService } from "../../services/timeslots.service";
import { PriceService } from "../../services/price.service";
import { ErrorHandler } from "../../../shared/services/error-handler.service";
import { BagItemsService } from "../../../shared/services/bagItems.service";
import { AppLoaderService } from "../../../shared/services/app-loader.service";
import { LoginService } from "../../../shared/services/login.service";
// models
import { AppState } from "../../models/app-state.interface";
import { TimeslotRequest } from "../../models/timeslot-request.interface";
import { TimeslotResponse } from "../../models/timeslot-response.interface";
import { TimeslotEmitData } from "../../models/timeslot-emit-data.interface";
import { UpsellBooking } from "../../models/upsell-booking.interface";
import { UserInitState } from "../../../shared/models/user-reducer.interface";
// globals
import {
  BAG_OPTIONS,
  MOBILE_MAX_WIDTH,
  CURRENCY_CODES
} from "../../../shared/globals";

import moment from "moment";
import {
  animate,
  keyframes,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

declare var ga: any;
declare var exponea: any;

@Component({
  selector: "app-hubdrop-timeslots",
  templateUrl: "./hubdrop-timeslots.component.html",
  styleUrls: ["./hubdrop-timeslots.component.scss"],
  animations: [
    trigger('Dropdown', [
      state('in', style({
        opacity: 1,
        'height': '100px',
        transform: 'translateY(0)'
      })),
      transition('void => *', [
        style({
          opacity: 0,
          'height': '0',
          transform: 'translateY(-10px)'
        }),
        animate(300, keyframes([
          style({
            'height': '100px',
            transform: 'translateY(0px)',
            offset: 0.75
          }),
          style({
            'height': '100px',
            transform: 'translateY(0px)',
            opacity: 1,
            offset: 1
          })
        ]))
      ]),
      transition('* => void', [
        animate(300, keyframes([
          style({
            opacity: 0,
            offset: 0.25
          }),
          style({
            'height': '0',
            transform: 'translateY(-10px)',
            offset: 1
          })
        ]))
      ])
    ])
  ]
})
export class HubdropTimeslotsComponent implements OnInit {
  @Input()
  originalAirlineCode;

  @Input()
  flightNumber;

  @Input()
  flightDateTime;

  @Input()
  flightDirection;

  @Input()
  zoneInfo;

  @Input()
  location;

  @Input()
  departureAirportCode;

  @Input()
  ccdAvailable;

  @Input()
  terminal;

  @Input()
  operatingCarrier;

  @Input()
  collectionDateTime;

  @Input()
  bookingProduct;

  @Input()
  appCopy;

  @Input()
  hasReserveError;

  @Input()
  hasReserveExpiredError;

  @Input()
  showLoader;

  @Input()
  amendZoneId;

  @Input()
  postOfficeData;

  @Input()
  selectedLanguage;

  @Input()
  selectedAddressType;

  @Input()
  postOfficeItems;

  @Output()
  checkReserveTimeslotData: EventEmitter<any> = new EventEmitter();

  @Output()
  sendBagNote: EventEmitter<any> = new EventEmitter();

  @Output()
  sendVirtualBags: EventEmitter<any> = new EventEmitter();

  @Output()
  sendBagItems: EventEmitter<any> = new EventEmitter();

  @Output()
  sendHasOversizedBag: EventEmitter<any> = new EventEmitter();

  @Output()
  goPanelBack: EventEmitter<any> = new EventEmitter();

  @Output()
  goPanelForward: EventEmitter<any> = new EventEmitter();

  private _bookingInitSubscription: Subscription;
  private _bookingStateSubscription: Subscription;
  private _priceSubscription: Subscription;
  private _timeslotDataSubscription: Subscription;
  private _timeslotsStateSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _upsellBookingSubscription: Subscription;
  private _priceLoadedSubscription: Subscription;
  private _userLoggedInSubscription: Subscription;
  private _userLoggedOutSubscription: Subscription;
  private _userSubscription: Subscription;
  private _updatedUserSubscription: Subscription;
  private _promoSubscription: Subscription;
  private _subscriptionSet = false;
  private _selectedTimeslot;
  private _selectedDateTime;
  private _bookingReference;
  private _resizeTimer;
  private _selectedPostOffice;
  private _hasDifferentPC = false;
  private _emptyTimeslotIdGuid = "00000000-0000-0000-0000-000000000000";
  private _bookingJourneyReference: string;

  public isMultiLeg = false;
  public arrivalCityName = "";
  public fromPrice = "";
  public selectedCurrencySymbol = "";
  public bagsArr = BAG_OPTIONS;
  public currentDate = "";
  public selectedDate = "";
  public isRadioDate = true;
  public selectedTimeslotId = null;
  public selectedGroupIndex = 0;
  public selectedTimeslotoverrideCapacity = null;
  public timeslotGroups = [];
  public upsellCheapestPrice: any;
  public slotsSetSize = 5;
  public timeslotElemHeight = 54;
  public includedBags = 0;
  public timeslots: TimeslotResponse = null;
  public radioDates = [];
  public radioDatesLength = 3;
  public showCalendar = false;
  public calendarMinDate;
  public calendarMaxDate;
  public disableDates = [];
  public showPlaneIconAtIndex = -1;
  public arrivalAirportText;
  public isTimeslotLoading = false;
  public isPriceLoading = false;
  public dataLoaded = false;
  public flightData;
  public flightStatusDetails;
  public departureAirlineCode;
  public arrivalAirlineCode;
  public timeslotsData = null;
  public manualFlightData = null;
  public hasFlightData = true;
  public hasManualFlightData = false;
  public flightFinalDestination = null;
  public currentBooking;
  public flightCount;
  public virtualBags = null;
  public firstLoad = true;
  public bagItems = null;
  public hasOversizedBag = false;
  public cantFindTime = false;
  public storeTimeslot;
  public airline;
  public airportTimeslotsWarning = false;
  public isAirportToAirport: Boolean;
  public bagNotes = "";
  public bookingData: TimeslotEmitData = {
    booking: {
      date: "",
      productTierId: null,
      timeslotId: null,
      changedBagsFlag: false,
      changedLocationFlag: false,
      changedTimeslotFlag: false,
    },
    timeslot: {
      timeslot: "",
      date: "",
      bookingReferenceId: "",
      timeSlotId: "",
      overrideTimeSlotCapacity: null,
      departureAirportCode: "",
    },
  };
  public price = null;
  public calendarLabelText = "Pick a date";
  public bookingType: string;
  public bookingJourneyTimeAmended: boolean;
  public newTimeslotSelected = false;
  public timeslotMessageDetails = {
    showMessage: false,
    title: "",
    message: "",
    translationMessage: [],
    isValid: false,
  };
  public timeslotMessageProductTierDetails = {
    showMessage: false,
    title: "",
    message: "",
    isValid: false,
  };
  public bookingAmendType = "none";
  public languageCode = "";
  public exponeaTriggered = false;
  public valueslots_available = 0;
  public premslots_available = 0;
  public toggleDropdown = true;
  public lastLegAirlineCode = "";
  public lastLegAirlineNumber = "";
  public lastLegAirportCode = "";
  public upsellbookingStatus: UpsellBooking = {} as UpsellBooking;
  public isSbbSubsidyApplied: boolean = false;
  public isDbSubsidyApplied: boolean = true;
  public dbSubsidyType: number | null;
  public isCatDiscountApplied: boolean = false;
  public isConditionalAcceptence: boolean = false;
  public user: UserInitState;
  public appliedPromotions: string[] = [];
  public userPromo = "";
  public promoPattern = /^\S*$/;
  public showPromoLoader: boolean = false;
  public currency;
  public flyBackRedirect;
  public flyBack;
  public setSelectedDateVal: boolean = true;

  constructor(
    private _appStore: Store<AppState>,
    private _eventsService: EventsService,
    private _bookingService: BookingService,
    private _timeslotService: TimeslotService,
    private _priceService: PriceService,
    private _errorService: ErrorHandler,
    private _loginService: LoginService,
    private _zone: NgZone,
    private _router: Router,
    private _bagItemsService: BagItemsService,
    private _appLoaderService: AppLoaderService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {

    const state = this.getState(this._appStore);
    const flybackReducer = state.flybackReducer
    this.flyBack = flybackReducer.flybackBooking
    this.flyBackRedirect = flybackReducer.flyBackRedirect

    this._bookingInitSubscription = this._appStore
      .select("loadedStatusReducer")
      .subscribe((res: any) => {
        // if booking data has bookingLoaded
        // show template and subscribe to data
        if (res.currentBookingLoaded && !this._subscriptionSet) {
          this.setDataSubscriptions();
        } else {
          return;
        }
      });
    this._userLanguageSubscription = this._appStore
      .select("copyReducer")
      .subscribe((res: any) => {
        this.selectedLanguage = res.language;
        this.languageCode = res.languageCode;
      });

    // set user values on login and logout
    this._userLoggedInSubscription = this._loginService.userSubject$.subscribe(
      (res) => {
        this.setUserValues(this.getState(this._appStore).userReducer);
      }
    );
    this._userLoggedOutSubscription =
      this._loginService.userLoggedOut$.subscribe((res) => {
        // this.hasSmsMarketingFlag = true;
        this.setUserValues(this.getState(this._appStore).userReducer);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.hasReserveError !== "undefined") {
      if (changes.hasReserveError.currentValue.hasError) {
        this._errorService.handleCustomError({
          text: "Sorry there was an issue selecting your timeslot. Please try again.",
          sticky: false,
        });
        this.handleTimeslotAPIData();
        this.scrollToTop();
        this.isTimeslotLoading = false;
      }
    }

    if (typeof changes.hasReserveExpiredError !== "undefined") {
      if (changes.hasReserveExpiredError.currentValue.hasError) {
        this._errorService.handleCustomError({
          text: "Your timeslot reservation has expired. Please select a new timeslot.",
          sticky: false,
        });
        this.handleTimeslotAPIData();
        this.scrollToTop();
        this.isTimeslotLoading = false;
      }
    }
    const isAmend = this.getState(this._appStore).bookingReducer.bookingDetails.bookingType === 'amend';
    if (((!changes.postOfficeData?.currentValue?.zoneId && this.amendZoneId) || changes.postOfficeData.previousValue?.zoneId !== changes.postOfficeData?.currentValue?.zoneId) && isAmend) {
      this.isTimeslotLoading = true;
      this.handleTimeslotAPIData();
    }

    if (changes.postOfficeData?.currentValue?.zoneId && isAmend) {
      this.bookingData.booking.changedLocationFlag = true;
    }
  }

  selectSlots(val, slots) {
    ga(
      "send",
      "event",
      "Vanilla",
      "Time - Slots",
      slots.timeslots.length + "-slots-available"
    );
    if (val === 0) {
      ga("send", "event", "Vanilla", "Time - Type Selected", "1hr");
    } else {
      ga("send", "event", "Vanilla", "Time - Type Selected", "3hr");
    }
  }

  overSizeBag(val: any) {
    if (val.currentTarget.checked === true) {
      ga("send", "event", "Vanilla", "Time - Oversized", "Yes");
    }
  }

  cantFindBooking(val: any) {
    if (val.currentTarget.checked === true) {
      ga("send", "event", "Error", "Can't find a time that works?");
    }
  }

  setDataSubscriptions() {
    // set init user values once on load
    this._userSubscription = this._appStore
      .select("userReducer")
      .pipe(take(1))
      .subscribe((user: UserInitState) => {
        this.setUserValues(user);
      });

    this.flightData = this.getState(this._appStore).flightReducer.flightDetails;
    this.currentBooking = this.getState(this._appStore).currentBookingReducer.currentBooking;
    this.isAirportToAirport = this.getState(this._appStore).bookingReducer.bookingDetails.isAirportToAirport;
    this._bookingReference = this.getState(this._appStore).bookingReducer.bookingDetails.bookingReference;
    this.bookingType = this.getState(this._appStore).bookingReducer.bookingDetails.bookingType;
    this.bookingJourneyTimeAmended = this.getState(this._appStore).bookingReducer.bookingDetails.bookingJourneyTimeAmended;

    // start for subsidy
    this.dbSubsidyType = this.getState(this._appStore).bookingReducer.bookingDetails.dbSubsidyType;
    let currentBookingDetails = null;

    if (this.flyBack && !this.flyBackRedirect) {
      currentBookingDetails = this.getState(this._appStore).oldBookingInfoReducer.abcBooking.bookingReducer.bookingDetails;
    } else {
      currentBookingDetails = this.getState(this._appStore).bookingReducer.bookingDetails;
    }

    this.isSbbSubsidyApplied = currentBookingDetails.isSbbSubsidyApplied;
    this.isDbSubsidyApplied = currentBookingDetails.isDbSubsidyApplied || currentBookingDetails.isLhSubsidyApplied;
    this.isCatDiscountApplied = currentBookingDetails.isCatDiscountApplied;

    this.dbSubsidyType = currentBookingDetails.dbSubsidyType;
    if (this.dbSubsidyType === null) {
      if (currentBookingDetails.isDbSubsidyApplied) {
        this.dbSubsidyType = 1;
      } else if (currentBookingDetails.isLhSubsidyApplied) {
        this.dbSubsidyType = 0;
      }
    }
    // end for subsidy

    // this.bookingAmendType = this.getState(this._appStore).bookingReducer.bookingDetails.bookingAmendType;
    this.bagNotes = this.currentBooking.bookingJourney[0].note.text;
    this.hasOversizedBag =
      this.currentBooking.bookingJourney[0].hasOversizedBag;
    this.virtualBags = this.currentBooking.bookingJourney[0].virtualBagCount;
    this.bagItems = this._bagItemsService.BagsClassificationToBagItems(
      this.currentBooking.bookingJourney[0].virtualBagClassification
    );
    this.flightStatusDetails = this.flightData.flightResponse.flightStatusDetails;
    this.departureAirlineCode = this.flightDirection === 1 ? this.flightStatusDetails[0].departureAirport.airportCode : null;
    this.arrivalAirlineCode = this.flightDirection === 2 ? this.flightStatusDetails[this.flightStatusDetails.length - 1].arrivalAirport.airportCode : null;
    this.appliedPromotions = this.getState(this._appStore).bookingReducer.bookingDetails.promo;
    this.userPromo = this.appliedPromotions[0];

    // amend looks for the price difference obj
    // set to false if not amend as price is called after user interaction
    if (this.bookingType !== "amend") {
      this.isPriceLoading = false;
    }

    // if amend, check location changed flag
    if (this.bookingType === "amend") {
      this.bookingData.booking.changedLocationFlag = this.getState(this._appStore).currentBookingReducer.amendBooking.amendBookingFlag === 32;
    }

    // check if saved postOffice used in timeslot request is the same as what's in booking obj
    // if not - get data again
    if (
      this.getState(this._appStore).hubDropReducer.selectedPostOffice !== null
    ) {
      this._selectedPostOffice = this.getState(this._appStore).hubDropReducer.selectedPostOffice;
      this._hasDifferentPC = this._selectedPostOffice.id !== this.postOfficeData.id;
    }

    this._bookingStateSubscription = this._appStore
      .select("bookingReducer")
      .subscribe((bookingState: any) => {
        this.storeTimeslot = bookingState.bookingDetails.timeslot;
        this.bookingAmendType = bookingState.bookingDetails.bookingAmendType;
        //  check this
        // this.isSbbSubsidyApplied = bookingState.bookingDetails.isSbbSubsidyApplied;

        // if bags have been changed, get timeslots with new prices
        if (
          this.firstLoad ||
          (this.virtualBags !== null &&
            this.virtualBags !== bookingState.bookingDetails.virtualBagCount)
        ) {
          this.virtualBags = bookingState.bookingDetails.virtualBagCount;
          this.bagItems = bookingState.bookingDetails.bagItems;
          this.isTimeslotLoading = true;
          this.bookingData.booking.changedBagsFlag = true;
          this.handleTimeslotAPIData();
          this.firstLoad = false;
        } else {
          this.virtualBags = bookingState.bookingDetails.virtualBagCount;
          this.bagItems = bookingState.bookingDetails.bagItems;
          this.appliedPromotions = bookingState.bookingDetails.promo;
        }

        // if (this._bagItemsService.getTotalItems(this.bagItems) !== 0 && this._bagItemsService.checkForbagItemsChange(this.bagItems, bookingState.bookingDetails.bagItems)) {
        // }
      });

    this._timeslotsStateSubscription = this._appStore
      .select("timeslotReducer")
      .subscribe((res: any) => {
        this.timeslotsData = res;
      });

    this._priceSubscription = this._appStore
      .select("priceReducer")
      .subscribe((price: any) => {
        this._zone.run(() => {
          if (Object.keys(price.price).length > 0) {
            this.price = price.price;
            this.isPriceLoading = false;
            // get timeslots if old price is not equal new price
            // if (this.price?.promoCodesApplied && (this.price?.promoCodesApplied[0] !== this.appliedPromotions[0])) {
            //   this.appliedPromotions = this.price.promoCodesApplied ?? [];
            //   this.handleTimeslotAPIData();
            //   this.isTimeslotLoading = true;
            // }
            // if (this.appliedPromotions.length > 0 && !this.price.promoCodesApplied) {
            //   this.appliedPromotions = [];
            //   this.handleTimeslotAPIData();
            //   this.isTimeslotLoading = true;
            // }
          }
        });
      });

    this._upsellBookingSubscription = this._appStore
      .select("upsellBookingReducer")
      .subscribe((res) => {
        this.upsellbookingStatus = res;
      });

    this._updatedUserSubscription = this._loginService.userIDSubject$.subscribe(
      (res) => {
        const newUserData = this.getState(this._appStore).userReducer;
        this.setUserValues(newUserData);
      }
    );

    this._promoSubscription = this._priceService.updatePromoSubject$.subscribe(
      (promo) => {
        this._zone.run(() => {
          this.showPromoLoader = false;
          if (promo.error) {
            return;
          }
          // get timeslots
          if (!this.isTimeslotLoading) {
            this.isTimeslotLoading = true;
            this.handleTimeslotAPIData();
          }
        });
      }
    );

    const promoIdUsed = this.getState(this._appStore).timeslotReducer.usedPromo;
    const promoId = this.getState(this._appStore).flightFinderReducer
      .promoFromUrl;
    // if timeslot has already been set in the store
    // refesh with values
    // else if no timeslot store data
    // or promo has been used and removed
    // set promo used to false when promo removed and nav back to timeslot from payment
    if (promoId === null && promoIdUsed) {
      this.timeslotsData.selectedTimeslotId = null;
      this.timeslotsData.overrideTimeSlotCapacity = null;
      this._appStore.dispatch({ type: "UPDATE_USED_PROMO", payload: false });
    }
    if (
      this.timeslotsData.selectedTimeslotId !== null &&
      !this._hasDifferentPC
    ) {
      this.setCurrentStoreVars();
    } else {
      this.handleTimeslotAPIData();
    }
    // comment else case `timeslot api was calling 2 time
    // else { this.handleTimeslotAPIData(); }

    // stop vars being set multiple times
    this._subscriptionSet = true;
  }

  toggleBagsDropdown() {
    if (isPlatformBrowser(this.platformId)) {
      this.toggleDropdown = !this.toggleDropdown;
    }
  }

  setCurrentStoreVars() {
    this.timeslots = this.timeslotsData.timeslotFormattedData;
    this.selectedDate = this.timeslotsData.selectedDate;
    this.selectedTimeslotId = this.timeslotsData.selectedTimeslotId;
    this.selectedTimeslotoverrideCapacity =
      this.timeslotsData.overrideTimeSlotCapacity;
    this.timeslotGroups = this.timeslots.timeSlotDates.find(
      (item) => item.dateTime === this.selectedDate
    ).timeslotGroups;
    this.selectedGroupIndex = this.timeslotGroups.findIndex(
      (group) =>
        group.productTierId === this.timeslotsData.selectedGroup.productTierId
    );
    this.includedBags =
      this.timeslotGroups[this.selectedGroupIndex].includedBags;
    if (isPlatformBrowser(this.platformId)) {
      this.handleDatesOnResize(window.innerWidth);
    }
    this.setSelectedDate(this.selectedDate);
    const currentAppState: any = this.getState(this._appStore);
    const bookingState = currentAppState.bookingReducer;
    this._bookingJourneyReference = bookingState.bookingDetails.bookingJourneyReference;

    // console.log('this.timeslotGroups', this.timeslotGroups[this.selectedGroupIndex].description);
    // console.log('this.timeslotGroups', this.timeslotGroups.length);
    if (this.timeslotGroups.length > 1) {
      ga("send", "event", "Vanilla", "Time - Type", "Both");
    } else {
      ga(
        "send",
        "event",
        "Vanilla",
        "Time - Type",
        this.timeslotGroups[this.selectedGroupIndex].description
      );
    }
    // vars for reserve timeslot request
    this._selectedTimeslot = {
      startTime: this.storeTimeslot.start,
      endTime: this.storeTimeslot.end,
    };

    this.airportTimeslotsWarning = this.storeTimeslot.airportTimeslotsWarning;

    this.setDateTimeStr();
    // this._priceService.getPrice('timeslot');
    this.dataLoaded = true;
  }

  getProductType() {
    console.log("ccd", this.ccdAvailable, "direction", this.flightDirection);
    console.log(this.ccdAvailable && this.flightDirection === 2);
    if (this.ccdAvailable && this.flightDirection === 2) {
      return [2];
    }
    if (this.bookingProduct === "abc") {
      return [1];
    }
    return [];
  }

  handleTimeslotAPIData() {
    // request for timeslot data
    const bookingType = this.getState(this._appStore).bookingReducer.bookingDetails.bookingType;
    const timeslotRequest: TimeslotRequest = {
      departureAirportCode: this.departureAirportCode,
      terminal: this.terminal,
      airline: this.originalAirlineCode,
      operatingCarrier: this.operatingCarrier,
      flightDateTime: this.flightDateTime,
      journeyDirection: this.flightDirection,
      addOnProductType: this.getProductType(),
      destination:
        this.flightDirection === 1
          ? this.flightStatusDetails[this.flightStatusDetails.length - 1]
            .arrivalAirport.airportCountryCode
          : null,
      clientProductTierIndicatorId: this.getState(this._appStore)
        .flightFinderReducer.productTierFromUrl,
      getBookingPriceRequest: {
        applySbbSubsidy: this.isSbbSubsidyApplied,
        applyDbSubsidy: this.isDbSubsidyApplied,
        applyCatDiscount: this.isCatDiscountApplied,
        dbSubsidyType: this.dbSubsidyType,
        numberOfBags: this.virtualBags === 0 ? 1 : this.virtualBags,
        numberOfOverSizedBags: this.bagItems?.oversizeItem ?? 0,
        airportLocation: this._priceService.formatAirportLocation(),
        postcode: this.location.addressPostCode,
        promotionId: this.getState(this._appStore).flightFinderReducer
          .promoFromUrl,
        flightDepartureAirportCode: this.getState(this._appStore).flightReducer
          .flightDetails.flightResponse.flightStatusDetails[0].departureAirport
          .airportCode,
        promocode: this.appliedPromotions[0]
          ? this.appliedPromotions[0]
          : undefined,
      },
      latitude: this.location.geoCoord.latitude,
      longitude: this.location.geoCoord.longitude,
      zoneId: !this.postOfficeData?.zoneId && bookingType === 'amend' ? this.amendZoneId : this.postOfficeData.zoneId
    };
    this._timeslotService.getTimeslots(timeslotRequest);

    this.timeslotMessageDetails.title = "";
    this.timeslotMessageDetails.message = "";
    this.timeslotMessageDetails.translationMessage = [];

    this._appStore.dispatch({
      type: "UPDATE_SELECTED_POSTCODE",
      payload: this.location.addressPostCode,
    });

    // RESPONSE
    // subscribe to returned timeslot data
    if (!this._timeslotDataSubscription) {
      this._timeslotDataSubscription =
        this._timeslotService.timeslotSubject$.subscribe(
          (res: TimeslotResponse) => {
            this.isTimeslotLoading = false;
            console.log(this.isTimeslotLoading, this.isPriceLoading, this.showLoader);
            // exponea
            const product_direction = this.flightDirection;
            let zone_name = this.zoneInfo.zoneId;
            let zone_description = this.zoneInfo.zoneDescription;
            this.valueslots_available = 0;
            let valueslots_minprice = 0;
            this.premslots_available = 0;
            let premslots_minprice = 0;
            let ecoslots_available = 0;

            // if no timeslots on any day
            // redirect to flight-finder/search
            if (res.validationErrorMessages !== null) {
              let errorCode = [];
              let message = res.validationErrorMessages.map((item) => {
                if (item.code === 762) {
                  return item.reasons[0];
                }
              });
              message = res.validationErrorMessages.map((item) => {
                if (item.code === 760) {
                  errorCode.push(760);
                  return item.reasons[0];
                }
              });

              // check if translation errors are available
              let params = [];
              if (res.translationResponse?.code) {
                errorCode = [res.translationResponse?.code];
                message =
                  res.translationResponse?.translationValidationErrors?.map(
                    (item) => {
                      params = Object.values(item.parameters);
                      return item.errorMessage;
                    }
                  );
              }

              if (errorCode.includes(760)) {
                setTimeout(() => {
                  this._router.navigate(["flight-finder/search"], {
                    queryParams: { "start-booking": true },
                  });
                }, 3000);
                this._errorService.handleCustomError(
                  { text: message, sticky: false },
                  true,
                  params
                );
                return;
              }

              // for other error codes
              if (!message || !message[0]) {
                message = res.validationErrorMessages.map(item => item.reasons[0]);
              }

              message = message[0];
              this._errorService.handleCustomError({ text: message, sticky: true });
              const state = this.getState(this._appStore);
              const currentBooking = this.flightDirection === 1 ? "abc" : "ccd";
              const upsellBooking = this.flightDirection === 1 ? "ccd" : "abc";
              const productAvailability =
                state.d2dReducer.flightDetails.flightProducts;

              /**
               * @upsell
               * when timeslots for second booking are not available but first booking steps are complete then navigate
               * user to payment screen for first booking
               */
              if (
                state.bookingReducer.bookingDetails.isD2dService &&
                state.d2dReducer.bookingCount === 2
              ) {
                // navigate to payment screen
                this._eventsService.goToBookingSwitcher(
                  upsellBooking,
                  "payment"
                );
                return;
              }

              /**
               * @upsell
               * when both services are available
               * and timeslots for first booking are not available
               * then ask user for upsell booking
               *
               * when timeslots for both services are not available then show the email screen
               */
              if (productAvailability.abc && productAvailability.ccd) {
                this._appStore.dispatch({
                  type:
                    currentBooking === "abc"
                      ? "UPDATE_ABC_TIMESLOT_STATUS"
                      : "UPDATE_CCD_TIMESLOT_STATUS",
                  payload: false,
                });
                this._appStore.dispatch({
                  type: "UPSELL_BOOKING_STATUS",
                  payload: {
                    showUpsellScreen: true,
                    currentBooking: currentBooking,
                    upsellBooking: upsellBooking,
                    upsellConverted: state.upsellBookingReducer.upsellConverted,
                  },
                });
              } else {
                /**
                 * @upsell
                 * when only one service is available
                 * and timeslots for first booking are not available then show user email screen
                 */
                this._appStore.dispatch({
                  type: "UPDATE_ABC_TIMESLOT_STATUS",
                  payload: false,
                });
                this._appStore.dispatch({
                  type: "UPDATE_CCD_TIMESLOT_STATUS",
                  payload: false,
                });
                this._appStore.dispatch({
                  type: "UPSELL_BOOKING_STATUS",
                  payload: {
                    showUpsellScreen: true,
                    currentBooking: currentBooking,
                    upsellBooking: upsellBooking,
                    upsellConverted: state.upsellBookingReducer.upsellConverted,
                  },
                });
              }
              return;
            }

            if (res.timeSlotPromotion !== null) {
              // if promo was used in request
              // set flag to true
              if (
                res.timeSlotPromotion.isPromotionValid &&
                this.getState(this._appStore).flightFinderReducer
                  .promoFromUrl !== null
              ) {
                this._appStore.dispatch({
                  type: "UPDATE_USED_PROMO",
                  payload: true,
                });
              }
            }

            this.timeslots = res;
            this.setTimeslotData();

            this.timeslotMessageDetails.showMessage =
              this.timeslots.timeSlotPromotion !== null;
            if (
              this.timeslotMessageDetails.showMessage &&
              (this.timeslotMessageDetails.title === "" ||
                this.timeslotMessageDetails.message === "")
            ) {
              const m = this.timeslots.timeSlotPromotion.translationValidationErrors.errorMessage.split("|");
              for (let i = 0; i < m.length; i++) {
                if (i === 0) {
                  this.timeslotMessageDetails.title = m[i].trim();
                } else {
                  this.timeslotMessageDetails.message +=
                    "<p>" + m[i].trim() + "</p>";
                  this.timeslotMessageDetails.translationMessage.push(
                    m[i].trim()
                  );
                }
              }
              this.timeslotMessageDetails.isValid =
                this.timeslots.timeSlotPromotion.isPromotionValid;
              if (this.timeslotMessageDetails.isValid) {
                this._appStore.dispatch({
                  type: "UPDATE_PROMO",
                  payload: this.timeslots.timeSlotPromotion.promotionApplied,
                });
              } else {
                this._appStore.dispatch({ type: "REMOVE_PROMO", payload: [] });
                this._appStore.dispatch({
                  type: "SAVE_PROMO_CODE",
                  payload: [],
                });
              }
            }

            this.timeslotMessageProductTierDetails.showMessage =
              this.timeslots.timeSlotProductTier !== null;
            if (
              this.timeslotMessageProductTierDetails.showMessage &&
              (this.timeslotMessageProductTierDetails.title === "" ||
                this.timeslotMessageProductTierDetails.message === "")
            ) {
              const m =
                this.timeslots.timeSlotProductTier.productTierMessage.split(
                  "|"
                );
              for (let i = 0; i < m.length; i++) {
                if (i === 0) {
                  this.timeslotMessageProductTierDetails.title = m[i];
                } else {
                  this.timeslotMessageProductTierDetails.message +=
                    "<p>" + m[i].trim() + "</p>";
                }
              }

              this.timeslotMessageProductTierDetails.isValid =
                this.timeslots.timeSlotProductTier.isProductTierValid;
            }
            if (this.timeslots.timeSlotDates.length > 0) {
              let currencySymbol;
              try {
                currencySymbol =
                  this.timeslots.timeSlotDates[0].timeslotGroups[0]
                    .currencySymbol;
              } catch (error) {
                currencySymbol = null;
              }
              this.currency = currencySymbol
                ? CURRENCY_CODES[currencySymbol]
                : { code: "GBP", symbol: "£" };
              this._appStore.dispatch({
                type: "UPDATE_CURRENCY",
                payload: this.currency,
              });
            }
            if (isPlatformBrowser(this.platformId)) {
              this.handleDatesOnResize(window.innerWidth);
            }
          }
        );
    }
  }

  checkPromoEvent(promo) {
    this.showPromoLoader = true;
    this._priceService.checkIfPromoValid({
      promoCode: this.userPromo,
      currency: this.currency?.code,
    });
  }

  handleRemovePromo() {
    this._appStore.dispatch({ type: "REMOVE_PROMO", payload: [] });
    this._appStore.dispatch({ type: "SAVE_PROMO_CODE", payload: [] });
    this.isTimeslotLoading = true;
    this.handleTimeslotAPIData();
  }

  setTimeslotData() {
    this.timeslots.timeSlotDates.map((date) => {
      date.timeslotGroups.map((group) => {
        const initIndex = group.timeslots.findIndex((t) => t.isRecommended);
        group.scrollIndex = initIndex > -1 ? initIndex : 0;
      });
    });

    let initSelectedDateIndex = this.timeslots.timeSlotDates.findIndex(
      (date) => date.isDefaultDate
    );

    // if BE doesn't send a default selected date, set last or first date from array
    if (initSelectedDateIndex === -1) {
      if (this.flightDirection === 1) {
        initSelectedDateIndex = this.timeslots.timeSlotDates.length - 1;
      } else {
        initSelectedDateIndex = 0;
      }
    }

    const initSelectedDate =
      this.timeslots.timeSlotDates[initSelectedDateIndex].dateTime;
    this.setSelectedDate(initSelectedDate);

    this._appStore.dispatch({
      type: "UPDATE_TIMESLOT_FORMATTED",
      payload: this.timeslots,
    });

    // if (this.flightDirection === 2 && this.timeslots.sdsInboundCollectionTimeSlot.errorMessage !== '') {
    //   this.airportTimeslotsWarning = true;
    // }

    // if amend and ONLY bags changed
    if (
      this.bookingType === "amend" &&
      this.bookingData.booking.changedBagsFlag &&
      !this.bookingData.booking.changedTimeslotFlag
    ) {
      this._priceService.getPrice("timeslot");
    } else if (
      (this.bookingData.booking.changedBagsFlag &&
        this.timeslotsData.selectedTimeslotId !== null) ||
      this.bookingData.booking.changedTimeslotFlag ||
      (this._hasDifferentPC && this.timeslotsData.selectedTimeslotId !== null)
    ) {
      this.setCurrentStoreVars();
    }
  }

  setDates() {
    this.disableDates = [];

    if (this.flightDirection === 1) {
      this.radioDates = this.timeslots.timeSlotDates.slice(
        -1 * this.radioDatesLength
      );

      if (this.timeslots.timeSlotDates.length > this.radioDatesLength) {
        const calendarDates = this.timeslots.timeSlotDates.slice(
          0,
          this.timeslots.timeSlotDates.length - this.radioDatesLength
        );

        this.showCalendar = true;
        this.calendarMinDate = calendarDates[0].dateTime;
        this.calendarMaxDate = calendarDates[calendarDates.length - 1].dateTime;

        // disable specific dates
        this.disableDates = this.timeslots.emptySlotsDays.map((item) => {
          const dateObj = {
            year: moment(item, "YYYY-MM-DDTHH:mm:ss").year(),
            month: moment(item, "YYYY-MM-DDTHH:mm:ss").month() + 1,
            day: moment(item, "YYYY-MM-DDTHH:mm:ss").date(),
          };

          return dateObj;
        });
      }
    } else {
      this.radioDates = this.timeslots.timeSlotDates.slice(
        0,
        this.radioDatesLength
      );

      if (this.timeslots.timeSlotDates.length > this.radioDatesLength) {
        const calendarDates = this.timeslots.timeSlotDates.slice(
          this.radioDatesLength,
          this.timeslots.timeSlotDates.length
        );

        this.showCalendar = true;
        this.calendarMinDate = calendarDates[0].dateTime;
        this.calendarMaxDate = calendarDates[calendarDates.length - 1].dateTime;

        // disable specific dates
        this.disableDates = this.timeslots.emptySlotsDays.map((item) => {
          const dateObj = {
            year: moment(item, "YYYY-MM-DDTHH:mm:ss").year(),
            month: moment(item, "YYYY-MM-DDTHH:mm:ss").month() + 1,
            day: moment(item, "YYYY-MM-DDTHH:mm:ss").date(),
          };

          return dateObj;
        });
      }
    }

    // if dates include day of flight, show plane icon
    this.showPlaneIconAtIndex = this.radioDates.findIndex(
      (date) =>
        moment(date.dateTime).format("DD/MM/YYYY") ===
        moment(this.flightDateTime).format("DD/MM/YYYY")
    );
  }

  navigateList(index, direction) {
    const item = JSON.parse(JSON.stringify(this.timeslotGroups));
    const group = item[index];
    if (direction === "earlier") {
      group.scrollIndex =
        group.scrollIndex > this.slotsSetSize
          ? group.scrollIndex - this.slotsSetSize
          : 0;
    } else if (direction === "later") {
      group.scrollIndex =
        group.scrollIndex + this.slotsSetSize * 2 <= group.timeslots.length - 1
          ? group.scrollIndex + this.slotsSetSize
          : group.timeslots.length - this.slotsSetSize;
      ga("send", "event", "Vanilla", "Time - Slots", "Later");
    }

    let pc = 0;
    let cheapestSlotCount = 0;
    // let startIndex = group.scrollIndex - 5 > 0 ? group.scrollIndex - 5 : 0;
    let endIndex =
      group.scrollIndex - 5 < 0 ? group.scrollIndex : group.scrollIndex + 5;
    let startIndex2 = group.scrollIndex + 5;
    // let endIndex2 = group.scrollIndex+5;

    for (let i = startIndex2 - 5; i < startIndex2; i++) {
      if (
        group.timeslots[i].isCheapest ||
        group.timeslots[i].totalPriceMajor !==
        group.timeslots[i].totalPriceBeforeDiscountMajor
      ) {
        cheapestSlotCount++;
      }
    }

    for (let i = 0; i < endIndex; i++) {
      if (
        group.timeslots[i].isCheapest ||
        group.timeslots[i].totalPriceMajor !==
        group.timeslots[i].totalPriceBeforeDiscountMajor
      ) {
        pc++;
      }
      if (i === group.scrollIndex - 1) break;
    }

    group.scrollPosition =
      group.scrollIndex * this.timeslotElemHeight + pc * 20;
    if (pc > 0) {
      group.scrollPosition += 2;
    }
    group.cheapestSlotCount = cheapestSlotCount;
    item[index] = group;
    this.timeslotGroups = item;
  }

  setSelectedDate(dateTime, date?) {
    if (date) {
      this.setSelectedDateVal = false;
    }
    this._appStore.dispatch({
      type: "UPDATE_TIMESLOT_SERVICE_DATE",
      payload: dateTime,
    });
    const d = moment(dateTime);

    d.set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
    });

    const formattedDateItem = d.format("YYYY-MM-DDTHH:mm:ss");

    this.currentDate = formattedDateItem;

    this.isRadioDate =
      this.radioDates.findIndex((date) => date.dateTime === this.currentDate) >
        -1
        ? true
        : false;
    this.timeslotGroups = this.timeslots.timeSlotDates.find(
      (item) => item.dateTime === this.currentDate
    ).timeslotGroups;
    this.dataLoaded = true;
    this.selectedGroupIndex =
      this.timeslotGroups.length - 1 >= this.selectedGroupIndex
        ? this.selectedGroupIndex
        : 0;
    const item = JSON.parse(JSON.stringify(this.timeslotGroups));
    let j = 0;
    for (const group of item) {
      let cheapestSlotCount = 0;
      const numslots = group.timeslots.length <= 5 ? group.timeslots.length : 5;
      for (let i = 0; i < numslots; i++) {
        if (
          group.timeslots[i].isCheapest ||
          group.timeslots[i].totalPriceMajor !==
          group.timeslots[i].totalPriceBeforeDiscountMajor
        )
          cheapestSlotCount++;
      }
      group.cheapestSlotCount = cheapestSlotCount;
      item[j] = group;
      j++;
    }
    this.timeslotGroups = item;

    ga("send", "event", "Vanilla", "Time Date", d.format("ddd D MMM YYYY"));
    if (this.timeslotGroups.length > 1) {
      ga("send", "event", "Vanilla", "Time - Type", "Both");
    } else {
      ga(
        "send",
        "event",
        "Vanilla",
        "Time - Type",
        this.timeslotGroups[this.selectedGroupIndex].description
      );
    }

    ga(
      "send",
      "event",
      "Vanilla",
      "Time - Slots",
      this.timeslotGroups[this.selectedGroupIndex].description +
      ", " +
      this.timeslotGroups[this.selectedGroupIndex].timeslots.length +
      "-slots-available"
    );

    this.setSelectedTimeslot(this.timeslotGroups[this.selectedGroupIndex].timeslots[0], this.selectedGroupIndex);
  }

  setSelectedTimeslot(ts, groupIndex) {
    this._selectedTimeslot = ts;
    this.newTimeslotSelected = true;
    this.selectedTimeslotId = ts.timeslotId;
    this.selectedTimeslotoverrideCapacity = ts.overrideTimeSlotCapacity;
    this.selectedDate = this.currentDate;
    const getState = this.getState(this._appStore);
    const bookingState = JSON.parse(JSON.stringify(getState));
    const flightReducer = bookingState.flightReducer;
    const bookingReducer = bookingState.bookingReducer;
    const currentBookingReducer = bookingState.currentBookingReducer;
    const priceReducer = bookingState.priceReducer;
    const timeslotReducer = bookingState.timeslotReducer;
    const flightFinderReducer = bookingState.flightFinderReducer;
    const currentBookingType = bookingState.bookingReducer.bookingDetails.bookingProduct;
    const hubDropReducer = bookingState.hubDropReducer;
    this._appStore.dispatch({ type: "UPDATE_SELECTED_DATE", payload: this.currentDate, });
    this._appStore.dispatch({ type: "UPDATE_SELECTED_GROUP", payload: this.timeslotGroups[groupIndex], });
    this._appStore.dispatch({ type: "UPDATE_SELECTED_TIMESLOT_ID", payload: this.selectedTimeslotId, });
    this._appStore.dispatch({ type: "UPDATE_SELECTED_TIMESLOT_OVERRIDE_CAPACITY", payload: this.selectedTimeslotoverrideCapacity, });
    this._appStore.dispatch({
      type: "SAVE_BOOKING_DETAILS",
      payload: {
        bookingType:
          currentBookingType === "abc" ? "outboundBooking" : "inboundBooking",
        flightReducer,
        bookingReducer,
        currentBookingReducer,
        priceReducer,
        timeslotReducer,
        flightFinderReducer,
        hubDropReducer,
        isCompleted: false,
      },
    });
    // timeslot value saved in booking reducer
    this._appStore.dispatch({
      type: "UPDATE_TIMESLOT",
      payload: {
        start: ts.startTime,
        end: ts.endTime,
        date: this.currentDate,
        id: this.selectedTimeslotId,
        overrideTimeSlotCapacity: this.selectedTimeslotoverrideCapacity,
        airportTimeslotsWarning: this.airportTimeslotsWarning,
      },
    });

    // if inbound, airport timeslot saved in booking reducer
    if (this.flightDirection === 2) {
      const airportTimeslot = this._selectedTimeslot;
      this._appStore.dispatch({
        type: "UPDATE_AIRPORT_TIMESLOT",
        payload: {
          start: airportTimeslot.startTime,
          end: airportTimeslot.endTime,
          date: airportTimeslot.startDateTime,
        },
      });
    }

    this.bookingData.booking.changedTimeslotFlag = true;
    this.selectedGroupIndex = groupIndex;
    this.includedBags = this.timeslotGroups[groupIndex].includedBags;

    this.setDateTimeStr();
    // this._priceService.getPrice('timeslot');
    // this.isPriceLoading = true;

    if (isPlatformBrowser(this.platformId)) {
      ga("send", "event", "Timeslot", this.timeslotGroups[groupIndex].name, ts.totalPriceMajor);
      ga("send", "event", "Timeslot", this.timeslotGroups[groupIndex].name, ts.totalPriceMajor);
    }

    const startTime = moment(this._selectedDateTime);
    const endTime = moment(this.flightDateTime);
    const difference = endTime.diff(startTime, "minutes");
    const airlineCode = this.flightStatusDetails[0].airlineCode;
    if (difference >= 1440 && airlineCode === "BA") {
      this.isConditionalAcceptence = false;
    } else {
      this.isConditionalAcceptence = true;
    }
  }

  setDateTimeStr() {
    const timeSplit = this._selectedTimeslot.startTime.split(":");
    const d = moment(this.currentDate);

    d.set({
      hour: timeSplit[0],
      minute: 0,
      second: 0,
      millisecond: 0,
    });

    this._selectedDateTime = d.format("YYYY-MM-DDTHH:mm:ss");
    this._appStore.dispatch({
      type: "UPDATE_SELECTED_TIMESLOT_DATETIME",
      payload: this._selectedDateTime,
    });
  }

  setUserValues(user) {
    this.user = user;
  }

  // bagItems?
  updateBagItems(bags, type) {
    this.isTimeslotLoading = true;
    this.bookingData.booking.changedBagsFlag = true;
    const bagsData = JSON.parse(JSON.stringify(this.bagItems));
    bagsData[type] = parseInt(bags, 10);
    this.bagItems = bagsData;
    this.sendBagItems.emit(this.bagItems);
    this.sendVirtualBags.emit(
      this._bagItemsService.getTotalItems(this.bagItems)
    );
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1)).subscribe((s) => (state = s));
    return state;
  }

  handleSubmit(event) {
    this.isTimeslotLoading = true;
    this._priceService.getPrice("timeslot");
    this._priceLoadedSubscription = this._priceService.priceLoaded$.subscribe(
      (data) => {
        if (data) {
          this.handleSubmitData(data);
          this._priceLoadedSubscription.unsubscribe();
        }
      }
    );
  }

  handleSubmitData(data?) {
    if (
      this.bookingType !== "amend" ||
      (this.bookingType === "amend" &&
        this.bookingData.booking.changedTimeslotFlag)
    ) {
      const d = moment(this._selectedDateTime);
      const minutes = this._selectedTimeslot.startTime.split(':')[1];
      d.set({ minute: +minutes });
      this._selectedDateTime = d.format("YYYY-MM-DDTHH:mm:ss");
      this.bookingData.timeslot = {
        timeslot: this._selectedTimeslot.startTime,
        date: this._selectedDateTime,
        bookingReferenceId: this._bookingReference,
        timeSlotId: this.selectedTimeslotId,
        overrideTimeSlotCapacity: this.selectedTimeslotoverrideCapacity,
        departureAirportCode: this.departureAirportCode,
      };

      this.bookingData.booking.date = this._selectedDateTime;

      if (this.bookingProduct === "ccd") {
        if (this.flightDirection === 1) {
          this.bookingData.booking.dateAirport =
            this.timeslotsData.timeslotFormattedData.sdsOutboundDeliveryTimeSlot.startDateTime;
        } else {
          this.bookingData.booking.dateAirport =
            this.timeslotsData.timeslotFormattedData.timeSlotDates.startDateTime;
        }
      }
    }

    if (
      this.bookingType === "amend" &&
      !this.bookingData.booking.changedTimeslotFlag
    ) {
      const amendData = {
        reference: this._bookingJourneyReference,
        flag: 32
      };
      this._bookingService.postAmend(amendData, true);

      this.bookingData.booking.productTierId = this.currentBooking.bookingJourney[0].productTierId;
      this.bookingData.booking.timeslotId = this.currentBooking.bookingJourney[0].timeSlotId === null || typeof this.currentBooking.bookingJourney[0].timeSlotId === "undefined" ? this._emptyTimeslotIdGuid : this.currentBooking.bookingJourney[0].timeSlotId;
      this.bookingData.booking.date = this.currentBooking.bookingJourney[0].collectionDateTimeUTC;
      if (this.flightDirection === 1) {
        this.bookingData.booking.date = this.currentBooking.bookingJourney[0].collectionDateTimeUTC;
      } else {
        this.bookingData.booking.date = this.currentBooking.bookingJourney[0].deliveryDateTimeUTC;
      }
    } else {
      this.bookingData.booking.productTierId = this.timeslotsData.selectedGroup.productTierId;
      this.bookingData.booking.timeslotId = this.selectedTimeslotId;
    }
    this._appStore.dispatch({ type: 'UPDATE_LOCATIONT_TYPE', payload: 'atPostOffice' });

    this.sendBagNote.emit(this.bagNotes);
    this.sendHasOversizedBag.emit(this.hasOversizedBag);
    this.sendBagItems.emit(this.bagItems);
    this.checkReserveTimeslotData.emit(this.bookingData);
    this.sendVirtualBags.emit(this.virtualBags);

    const state = this.getState(this._appStore);
    const slot_type = this.timeslotsData.selectedGroup.description.replace(
      /[^0-9.]/g,
      ""
    );

    const isHubdropBooking = this.selectedAddressType === 'atPostOffice';
    const flightDepartureDate = state.flightReducer.flightDetails.flightResponse?.flightInfo?.requestedDateTime || '';
    const selectedGroup = state.timeslotReducer.selectedGroup;
    let selectedTimeslotDateTime = ''
    if (selectedGroup?.dateTime) {
      const d = moment(selectedGroup.dateTime);
      const t = selectedGroup.timeslots[0].startTime.split(':')
      d.set({
        hour: t[0],
        minute: t[1],
        second: 0,
        millisecond: 0,
      });

      selectedTimeslotDateTime = d.format("YYYY-MM-DDTHH:mm:ss");
    }

    exponea.track("oldfunnel_timeslots", {
      product_direction: this.flightDirection === 1 ? "abc" : "ccd",
      slot_time: `${this._selectedTimeslot.startTime + " - " + this._selectedTimeslot.endTime}`,
      slot_type: this.timeslotsData.selectedGroup?.name,
      subsidy_available: state.bookingReducer.bookingDetails.isSbbSubsidyAvailable,
      subsidy_amount: state.priceReducer.sbbSubsidyAmount,
      subsidy_currency: data.totalPrice.currencySymbol,
      public_transportation: state.bookingReducer.bookingDetails.isSbbSubsidyApplied,
      ecoslot: this._selectedTimeslot?.timeslotFlags?.includes("Eco slot") ? true : false,
      peak_surcharge_available: this._selectedTimeslot?.timeslotFlags?.includes("Peak time") ? true : false,
      product_selection: 'hubdrop',
      post_office_name: this.postOfficeData.name,
      post_office_distance: this.postOfficeData.distance,
      drop_off_date: isHubdropBooking ? selectedTimeslotDateTime : '',
      flight_departure_date: flightDepartureDate,
      post_office_price: selectedGroup.currencySymbol + selectedGroup.timeslots[0].totalPriceMajor,
      timeslot_price: '',
      latitude: this.postOfficeData.geoCoord.latitude,
      longitude: this.postOfficeData.geoCoord.longitude,
      entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
    });
  }

  goBack() {
    this.goPanelBack.emit(true);
  }

  cancelAmend() {
    this._router.navigate(["my-account/bookings/booking-details"], {
      queryParams: { ref: this.currentBooking.bookingReference },
    });
  }

  scrollToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  ngOnDestroy() {
    this._bookingInitSubscription.unsubscribe();
    if (this._bookingStateSubscription) {
      this._bookingStateSubscription.unsubscribe();
    }
    if (this._timeslotDataSubscription) {
      this._timeslotDataSubscription.unsubscribe();
    }
    if (this._timeslotsStateSubscription) {
      this._timeslotsStateSubscription.unsubscribe();
    }
    if (this._priceSubscription) {
      this._priceSubscription.unsubscribe();
    }
    if (this._userLanguageSubscription) {
      this._userLanguageSubscription.unsubscribe();
    }
    if (this._upsellBookingSubscription) {
      this._upsellBookingSubscription.unsubscribe();
    }
    if (this._userSubscription) {
      this._userSubscription.unsubscribe();
    }
    if (this._userLoggedInSubscription) {
      this._userLoggedInSubscription.unsubscribe();
    }
    if (this._userLoggedOutSubscription) {
      this._userLoggedOutSubscription.unsubscribe();
    }
    if (this._updatedUserSubscription) {
      this._updatedUserSubscription.unsubscribe();
    }
    if (this._promoSubscription) {
      this._promoSubscription.unsubscribe();
    }
  }

  handleDatesOnResize(screenWidth) {
    const isMobile = screenWidth <= MOBILE_MAX_WIDTH ? true : false;

    this.setDates();

    this.isRadioDate =
      this.radioDates.findIndex((date) => date.dateTime === this.currentDate) >
        -1
        ? true
        : false;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => {
      const screenWidth = event.target.innerWidth;
      this.handleDatesOnResize(screenWidth);
    }, 500);
  }
}
